"use client"

import { useState } from "react"

type FaqItem = { q: string; a: string }

// Accordéon minimal (une question ouverte à la fois) — pas de dépendance
// ajoutée, cohérent avec le principe de charge cognitive réduite déjà
// appliqué ailleurs dans le produit (cf. AccordionSection côté PWA).
export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {items.map((item, i) => {
        const isOpen = openIndex === i
        return (
          <div
            key={item.q}
            style={{
              background: "rgba(255,255,255,0.03)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 14,
              overflow: "hidden",
            }}
          >
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : i)}
              aria-expanded={isOpen}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
                padding: "18px 20px",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                textAlign: "left",
                minHeight: 44,
              }}
            >
              <span style={{ fontSize: 15, fontWeight: 700, color: "var(--foreground)" }}>
                {item.q}
              </span>
              <i
                className="ti ti-chevron-down"
                aria-hidden="true"
                style={{
                  fontSize: 18,
                  color: "#a09ae8",
                  flexShrink: 0,
                  transition: "transform .2s",
                  transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                }}
              />
            </button>
            {isOpen && (
              <p style={{
                fontSize: 14, lineHeight: 1.65, color: "var(--muted-foreground)",
                margin: 0, padding: "0 20px 18px",
              }}>
                {item.a}
              </p>
            )}
          </div>
        )
      })}
    </div>
  )
}
